import React, { Component } from 'react';
import { Grid, Cell, Checkbox, TextField } from 'react-md';
import { Link, Redirect } from 'react-router-dom';
import validate from 'validate.js';

import './Contacts.css';

import { state, isStateEmpty } from '../services/state';

validate.validators.atLeastOneContact = function(
	value,
	options,
	key,
	attributes
) {
	console.log({ value });
	if (!value) {
		return 'must not be empty';
	}
	if (value.size < 1) {
		return 'must not be empty';
	}
};

validate.validators.presenceIfOtherSelected = function(
	value,
	options,
	key,
	attributes
) {
	if (
		attributes.selectedContacts &&
		attributes.selectedContacts.has('other')
	) {
		if (!value) {
			return 'must be present if other is selected.';
		}
	}
};

class Contacts extends Component {
	constraints = {
		selectedContacts: {
			atLeastOneContact: true
		},
		otherContactName: {
			//email: true,
			presenceIfOtherSelected: true
		}
	};

	constructor(props) {
		super(props);

		let contacts = [];
		if (window.uploaderContacts) {
			contacts = [...window.uploaderContacts];
		} else {
			// dev
			contacts = [
				{
					name: 'Test Uploader 1',
					email: 'testuploader1@example.com'
				},
				{
					name: 'Test Uploader 2',
					email: 'testuploader2@example.com'
				},
				{
					name: 'Test Uploader 3',
					email: 'testuploader3@example.com'
				},
				{
					name: 'Test Uploader 4',
					email: 'testuploader4@example.com'
				},
				{
					name: 'Test Uploader 5',
					email: 'testuploader5@example.com'
				}
			];
		}

		// append other
		contacts.push({
			name: 'Other',
			email: 'other'
		});

		let selectedContacts = state.selectedContacts;

		this.state = {
			contacts,
			selectedContacts,
			otherContactName: state.otherContactName
		};
	}

	contactChanged = (checked, event) => {
		let { selectedContacts } = this.state;
		if (checked === true) {
			selectedContacts.add(event.target.value);
		} else {
			selectedContacts.delete(event.target.value);
		}
		state.selectedContacts = selectedContacts;
		this.setState({
			selectedContacts
		});
	};

	otherNameChanged = (value, event) => {
		state.otherContactName = value;
		this.setState({
			otherContactName: value
		});
	};

	isValid = () => {
		this.validation = validate(state, this.constraints);
		console.log('validation', this.validation);
		return !this.validation;
	};

	nextClick = event => {
		if (!this.isValid()) {
			event.stopPropagation();
			event.preventDefault();
			return false;
		}
	};

	render() {
		if (isStateEmpty()) {
			return <Redirect to="/" />;
		}

		let { contacts, selectedContacts, otherContactName } = this.state;
		const isValid = this.isValid();

		return (
			<div className="Contacts">
				<Grid>
					<Cell
						size={6}
						tabletOffset={1}
						desktopOffset={3}
						className="title-wrapper"
					>
						<h2 className="sub-section-title">
							Select your Image Mill contact(s)
						</h2>
					</Cell>
				</Grid>
				<Grid>
					<Cell
						size={8}
						tabletOffset={1}
						desktopOffset={2}
						className="contacts-selection-wrapper"
					>
						<Grid className="contacts">
							{contacts.map((contact, index) => {
								return (
									<Cell
										size={6}
										className="contact"
										key={index}
									>
										<Checkbox
											name="contact-checkboxes[]"
											label={contact.name}
											onChange={this.contactChanged}
											checked={selectedContacts.has(
												contact.email
											)}
											id={`contact-${index}`}
											checkedIcon={
												<div className="checkbox-icon checked-checkbox-icon" />
											}
											uncheckedIcon={
												<div className="checkbox-icon unchecked-checkbox-icon" />
											}
											value={contact.email}
										/>
										{contact.name === 'Other' &&
											selectedContacts.has('other') && (
												<div>
													<TextField
														name="other-contact-name"
														type="text"
														id="other-contact-name"
														onChange={
															this
																.otherNameChanged
														}
														placeholder="Contact Name..."
														fullWidth={true}
														defaultValue={
															otherContactName
														}
													/>
												</div>
											)}
									</Cell>
								);
							})}
						</Grid>
					</Cell>
				</Grid>
				<Grid className="next-wrapper">
					<Cell size={6} tabletOffset={1} desktopOffset={3}>
						<Link to="/estimate" className="primary-button">
							<i className="uploader-icon uploader-icon-Previous-Arrow" />{' '}
							Previous
						</Link>
						<Link
							to="/upload"
							onClick={this.nextClick}
							className={`primary-button ${
								isValid ? '' : 'disabled'
							}`}
						>
							Next{' '}
							<i className="uploader-icon uploader-icon-Next-Arrow" />
						</Link>
					</Cell>
				</Grid>
			</div>
		);
	}
}

export default Contacts;



// WEBPACK FOOTER //
// ./src/pages/Contacts.js